import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../axiosApi';

const initialState = {};

export const callHistoryGet = createAsyncThunk('report/call_history', async (params) => {
  return await apiInstance.get('/cdrs_report/call_history', { params });
});

export const liveCallHistoryGet = createAsyncThunk('report/live-call_history', async (params) => {
  return await apiInstance.get('/crm-history/', { params });
});

const callHistorySlice = createSlice({
  name: 'callHistory',
  initialState,
  reducers: {
    clearCallHistorySlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default callHistorySlice.reducer;
export const { clearCallHistorySlice } = callHistorySlice.actions;
